// extracted by css-extract-rspack-plugin
export default {"mark":"j9BskdO6N487cQxP"};